import clsx from "clsx";

export const YStack: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({className, ...rest}) => {
  return <div className={clsx("flex flex-col", className)} {...rest} />;
};
